export default "__VITE_ASSET__ccee1390__"